export default __webpack_public_path__ + "static/mx-7ca2f7d648843876f0317781ed439d84.png";